import clsx from 'clsx';
import React, { FC } from 'react';

import ArrowRightShort from '1_components/SVGs/ArrowRightShort';
import LinkArrow from '1_components/SVGs/LinkArrow';
import LocationMarkerThick from '1_components/SVGs/LocationMarkerThick';
import Facebook from '1_components/SVGs/socials/Facebook';
import Instagram from '1_components/SVGs/socials/Instagram';
import LinkedIn from '1_components/SVGs/socials/LinkedIn';
import Mail from '1_components/SVGs/socials/Mail';
import X from '1_components/SVGs/socials/X';
import SvgCaret from '1_components/SVGs/SvgCaret';
import LocationMarker from '1_components/SVGs/SvgLocationMarker';
import WeatherCloudy from '1_components/SVGs/weather/WeatherCloudy';
import WeatherFire from '1_components/SVGs/weather/WeatherFire';
import WeatherRainy from '1_components/SVGs/weather/WeatherRainy';
import WeatherStormy from '1_components/SVGs/weather/WeatherStormy';
import WeatherSunny from '1_components/SVGs/weather/WeatherSunny';
import WeatherWindy from '1_components/SVGs/weather/WeatherWindy';

import ArrowRight from '../SVGs/ArrowRight';
import Logotype from '../SVGs/branding/logoType';
import Headphones from '../SVGs/Headphones';
import Location from '../SVGs/Location';

import S from './Icon.module.scss';

export type IconVariant =
  | 'ArrowRight'
  | 'ArrowRightShort'
  | 'ArrowLeft'
  | 'ArrowBottom'
  | 'ArrowTop'
  | 'Location'
  | 'LocationMarker'
  | 'Headphones'
  | 'Logotype'
  | 'Facebook'
  | 'Instagram'
  | 'LinkedIn'
  | 'Mail'
  | 'LinkArrow'
  | 'WeatherCloudy'
  | 'WeatherFire'
  | 'WeatherRainy'
  | 'WeatherStormy'
  | 'WeatherSunny'
  | 'WeatherWindy'
  | 'Sunny'
  | 'Cloudy'
  | 'Rainy'
  | 'Windy'
  | 'Stormy'
  | 'ChevronLeft'
  | 'ChevronRight'
  | 'ChevronTop'
  | 'ChevronBottom'
  | 'LocationMarkerThick'
  | 'X';

export interface IconProps {
  className?: string;
  variant: IconVariant;
}

const SvgIcons: Record<IconVariant, FC<{ className?: string }>> = {
  ArrowRight: ArrowRight,
  ArrowRightShort: ArrowRightShort,
  ArrowBottom: ({ className }) => (
    <ArrowRight className={clsx(S.ArrowBottom, className)} />
  ),
  ArrowTop: ({ className }) => (
    <ArrowRight className={clsx(S.ArrowTop, className)} />
  ),
  ArrowLeft: ({ className }) => (
    <ArrowRight className={clsx(S.ArrowLeft, className)} />
  ),

  ChevronLeft: SvgCaret,
  ChevronBottom: ({ className }) => (
    <SvgCaret className={clsx(S.ChevronBottom, className)} />
  ),
  ChevronTop: ({ className }) => (
    <SvgCaret className={clsx(S.ChevronTop, className)} />
  ),
  ChevronRight: ({ className }) => (
    <SvgCaret className={clsx(S.ChevronRight, className)} />
  ),

  Location: Location,
  LocationMarker: LocationMarker,
  Headphones: Headphones,
  Logotype: Logotype,
  Facebook: Facebook,
  Instagram: Instagram,
  LinkedIn: LinkedIn,
  Mail: Mail,
  LinkArrow: LinkArrow,
  WeatherCloudy,
  WeatherFire,
  WeatherRainy,
  WeatherStormy,
  WeatherSunny,
  WeatherWindy,
  Sunny: WeatherSunny,
  Cloudy: WeatherCloudy,
  Rainy: WeatherRainy,
  Windy: WeatherWindy,
  Stormy: WeatherStormy,
  LocationMarkerThick,
  X,
};

const Icon: React.FC<IconProps> = ({ variant, className }) => {
  const SVG = SvgIcons[variant];

  if (!SVG) {
    throw new Error(`Invalid icon variant: ${variant}`);
  }

  return (
    <div className={className}>
      <SVG className={S.Icon} />
    </div>
  );
};

export default Icon;
